import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

import { createAnchorToLinkReplacer } from '#src/shared/ds';

export const Header: React.FC = () => {
	return (
		<Text as="div" className="text-typography-weak" id="abuse-modal-form-description">
			<TranslateHtml
				value="fe.components.petition_report_abuse.form_description"
				replacements={{ tosUrl: '/policies/terms-of-service', cgUrl: '/policies/community' }}
				replace={createAnchorToLinkReplacer()}
			/>
		</Text>
	);
};
